import { DateTime } from 'luxon';

export const formatAmount = (amount, config = {}) => {
  const { amountMaxFactor = 2, amountMinFactor = 2, local = 'en-US' } = config;

  const isInvalidAmount =
    !Number(amount) || amount instanceof DateTime || typeof amount === 'object';

  if (isInvalidAmount) {
    return amount;
  }

  return new Intl.NumberFormat(local, {
    minimumFractionDigits: amountMinFactor,
    maximumFractionDigits: amountMaxFactor
  }).format(amount);
};
